


import React, { useState, useCallback, useEffect, useRef } from 'react';
import {
  Image as ImageIcon,
  Video as VideoIcon,
  Rss,
  Hash,
  FileUp,
  Music,
  Eye,
  Repeat,
  XCircle,
  UserCircle,
  Heart,
  ThumbsUp,
  MessageSquare,
  Share2,
  Plus,
  Globe,
  Upload,
  MessageCircle,
  Check,
  ArrowRight,
  ArrowLeft,
  X,
  Twitter,
  Youtube,
  Linkedin,
  Calendar,
  Facebook,
  Instagram,
  Paperclip,
  TriangleAlert
} from 'lucide-react';
import { Square, RectangleHorizontal, RectangleVertical, Expand } from "lucide-react";
import FacebookImagePreview from '../../components/modals/FacebookImagePreview';
import { v4 as uuidv4 } from "uuid";
import { Mic, StopCircle } from 'lucide-react';
import FaPinterest from 'react-icons/fa'; // Pinterest (assuming this import is correct for your setup)
import EmojiPicker from 'emoji-picker-react';
import ProgressBar from '@ramonak/react-progress-bar'; // Corrected import path with quotes
import Swal from 'sweetalert2'; // Corrected import path with quotes and semicolon
import Cropper from 'react-easy-crop'; // Import the Cropper component
import { getCroppedImg } from './canvasUtils'; // Import the utility for cropping
import TagsInput from "react-tagsinput";
import "react-tagsinput/react-tagsinput.css";
import TagsModal from '../../components/modals/TagsModal';
import MediaPreviewSlider from '../../components/modals/MediaPreviewSlider';
import { faCopy } from "@fortawesome/free-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import MediaGrid from '../../components/modals/MediaGrid';
import { useNavigate } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import { apiUrl, assetsUrl } from '../../config/Config';
import axios from 'axios';
import { useDispatch, useSelector } from 'react-redux';
import Overlay from '../../components/Overlay';

const formatTime = (seconds) => {
  const m = Math.floor(seconds / 60).toString().padStart(2, '0');
  const s = Math.floor(seconds % 60).toString().padStart(2, '0');
  return `${m}:${s}`;
};

const Facebookpost = () => {
  const dispatch = useDispatch();
  const userdata = useSelector((store) => store.userReducer.userdata);
  const samplepagesdata = {
    "Facebook": {
      icon: Facebook, color: "#1877F2", pagelist: [
        { id: "", access_token: "", name: "ConsultHagnos", isselected: "false", platform: "Facebook", selectedhashtags: "" },
        { id: "", access_token: "", name: "HagnosTech", isselected: "false", platform: "Facebook", selectedhashtags: "" },
        { id: "", access_token: "", name: "OurBHK", isselected: "false", platform: "Facebook", selectedhashtags: "" },
      ]
    },
    "LinkedIn": {
      icon: Linkedin, color: "#1877F2", pagelist: [
        { id: "", access_token: "", name: "ConsultHagnos", isselected: "false", platform: "LinkedIn", selectedhashtags: "" },
        { id: "", access_token: "", name: "HagnosTech", isselected: "false", platform: "LinkedIn", selectedhashtags: "" },
      ]
    },
    "Instagram": {
      icon: Instagram, color: "#1877F2", pagelist: [
        { id: "", access_token: "", name: "ConsultHagnos", isselected: "false", platform: "Instagram", selectedhashtags: "" },
        { id: "", access_token: "", name: "HagnosTech", isselected: "false", platform: "Instagram", selectedhashtags: "" },
      ]
    },
    "Twitter": {
      icon: Twitter, color: "#1877F2", pagelist: [
        { id: "", access_token: "", name: "ConsultHagnos", isselected: "false", platform: "Twitter", selectedhashtags: "" },
      ]
    },
    "Youtube": {
      icon: Youtube, color: "#1877F2", pagelist: [
        { id: "", access_token: "", name: "ConsultHagnos", isselected: "false", platform: "Youtube", selectedhashtags: "" },
      ]
    }
  }
  // State Variables
  const [postType, setPostType] = useState('Photos'); // Type of post (Photos, Videos, Feed)
  const [postname, setpostname] = useState("");
  const [description, setDescription] = useState(''); // Post description text
  const [hashtags, setHashtags] = useState([]); // List of selected hashtags
  const [hashtagInput, setHashtagInput] = useState([]); // Current input for hashtags
  const [showHashtagSuggestions, setShowHashtagSuggestions] = useState(false); // Toggle for hashtag suggestions
  const [currentStep, setCurrentStep] = useState(1); // Current step in the post creation process
  const [mediaFiles, setMediaFiles] = useState([]); // Final list of media files attached to the post
  const [audioFile, setAudioFile] = useState(null); // Attached audio file
  const [audioDuration, setAudioDuration] = useState(0); // Duration of the audio file
  const [trimOption, setTrimOption] = useState(30); // Audio trim option (30s or 60s)
  const [trimStart, setTrimStart] = useState(0); // Audio trim start time
  const [trimEnd, setTrimEnd] = useState(0); // Audio trim end time
  const [audioUrl, setAudioUrl] = useState(null); // URL for audio preview
  const [showPreviewModal, setShowPreviewModal] = useState(false); // Toggle for post preview modal
  const [showGalleryModal, setShowGalleryModal] = useState(false); // Toggle for media gallery modal
  const [tempSelectedMedia, setTempSelectedMedia] = useState([]); // Temporarily selected media in gallery modal
  const [feedbackMessage, setFeedbackMessage] = useState(''); // User feedback message
  const [completedBarCount, setCompletedBarCount] = useState(12); // Progress bar completion percentage
  const completedBarCountRef = useRef(12); // Ref to keep track of progress bar count for useEffect
  const [selectedPlatform, setSelectedPlatform] = useState('Facebook'); // Currently selected social media platform
  const [selectedPages, setSelectedPages] = useState([]); // Selected pages/accounts for the chosen platform
  const [showEmojiPicker, setShowEmojiPicker] = useState(false);
  const [showEmojiPicker1, setShowEmojiPicker1] = useState(false); // Toggle for emoji picker

  const selectedPlatformRef = useRef(null);
  selectedPlatformRef.current = selectedPlatform;

  const [showFullGallery, setShowFullGallery] = useState(false);
  const [galleryImages, setGalleryImages] = useState([]);
  const [currentIndex, setCurrentIndex] = useState(0);
  const selectedPagesRef = useRef(null);
  selectedPagesRef.current = selectedPages;
  const navigate = useNavigate();
  const [allpagesdata, setallpagesdata] = useState({});
  const allpagesdataRef = useRef({});
  allpagesdataRef.current = allpagesdata;

  console.log('selectedPagesRef.current >>', selectedPagesRef.current);

  const [forcestateupdate, setforcestateupdate] = useState(false);
  const [showtrendingtagsmodal, setshowtrendingtagsmodal] = useState(false);
  const [selectedfortagmodal, setselectedfortagmodal] = useState({});
  const selectedfortagmodalRef = useRef({});
  selectedfortagmodalRef.current = selectedfortagmodal;
  const [islinkedinselected, setislinkedinselected] = useState(false);
  const [istwitterselected, setistwitterselected] = useState(false);
  const [isseperatefortwittercheckbox, setisseperatefortwittercheckbox] = useState(false);
  const [showtwitterwarning, setshowtwitterwarning] = useState(false);
  const [twitterdescription, settwitterdescription] = useState("");
  const [croppingQueue, setCroppingQueue] = useState([]);
  //--- State for Image Cropping Feature
  const [imageToCrop, setImageToCrop] = useState(null); // URL of the image currently being cropped
  const [crop, setCrop] = useState({ x: 0, y: 0 }); // Crop position
  const [zoom, setZoom] = useState(1); // Zoom level for cropping
  const [croppedPixels, setCroppedPixels] = useState(null); // Pixel dimensions of the cropped area
  const [showCropperModal, setShowCropperModal] = useState(false); // Toggle for the cropping modal
  const [cropAspectRatio, setCropAspectRatio] = useState(null); // Aspect ratio for cropping (e.g., 1/1, 4/5)
  const [selectedImage, setSelectedImage] = useState(null);
const [aspect, setAspect] = useState(undefined); // default = Original (free crop)
  const [croppedFileMeta, setCroppedFileMeta] = useState(null);
  const [issamehashtag, setissamehashtag] = useState(true);

  const [mediaPlatformTab, setMediaPlatformTab] = useState('Facebook');
  // const [selectedAspectRatio, setSelectedAspectRatio] = useState(null);
  console.log('islinkedinselected >>', islinkedinselected);
  console.log('istwitterselected >>', istwitterselected);

  const [linkedInPDF, setLinkedInPDF] = useState(null);
  const [linkedInPDFTitle, setLinkedInPDFTitle] = useState("");

  const [showLoading, setShowLoading] = useState(false);
  const [finalloading, setfinalloading] = useState(false);


  const handletoggleselectedpages = (platform, index, value) => {
    var prevdata = allpagesdataRef.current;
    // console.log('test >> ', prevdata[platform]?.pagelist[index]?.isselected)
    if (value == "false") {
      prevdata[platform].pagelist[index].isselected = "true";
    } else {
      prevdata[platform].pagelist[index].isselected = "false";
    }
    setallpagesdata(prevdata);
    setforcestateupdate(!forcestateupdate);

    // for selected pages
    // console.log('prevdata >>', Object.keys(prevdata)?.length);
    var prevdatakeys = Object.keys(prevdata);
    var count = 0;
    var selectedpagearr = [];
    setislinkedinselected(false);
    setistwitterselected(false);
    for (var i = 0; i < prevdatakeys?.length; i++) {
      var pagelistarr = prevdata[prevdatakeys[i]]?.pagelist;
      for (var p = 0; p < pagelistarr?.length; p++) {
        if (pagelistarr[p]?.isselected == "true") {
          // count = count + 1;
          selectedpagearr.push(pagelistarr[p]);
          if (pagelistarr[p]?.platform == "LinkedIn") {
            setislinkedinselected(true);
          }
          if (pagelistarr[p]?.platform == "Twitter") {
            setistwitterselected(true);
          }
        }
      }
    }
    console.log('selectedpagearr >>', selectedpagearr);
    setSelectedPages(selectedpagearr);

  }
  // const aspectRatios = {
  //   Facebook: [{ label: '16:9', value: 16 / 9 }, { label: '4:3', value: 4 / 3 }],
  //   Instagram: [{ label: '1:1', value: 1 }, { label: '4:5', value: 4 / 5 }],
  //   LinkedIn: [{ label: '1.91:1', value: 1.91 }, { label: '1:1', value: 1 }],
  //   Twitter: [{ label: '16:9', value: 16 / 9 }, { label: '1:1', value: 1 }],
  // };
  //--- Mock Data
  const mockPlatforms = {
    Facebook: [
      { id: '1', name: 'FB Page 1', type: 'Business' },
      { id: '2', name: 'FB Page 2', type: 'Creator' },
    ],
    LinkedIn: [
      { id: '5', name: 'LinkedIn Page 1', type: 'Company' },
      { id: '6', name: 'LinkedIn Page 2', type: 'Company' },
    ],
    Instagram: [
      { id: '3', name: 'Insta Account 1', type: 'Business' },
      { id: '4', name: 'Insta Account 1', type: 'Personal' },
    ],
    Twitter: [
      { id: '7', name: 'Twitter Account 1', type: 'Business' },
      { id: '8', name: 'Twitter Account 2', type: 'Personal' },
    ],
    YouTube: [
      { id: '9', name: 'YouTube Channel 1', type: 'Brand' },
      { id: '10', name: 'YouTube Channel 2', type: 'Creator' },
    ],
  };

  const mockTrendingHashtags = [
    '#digitalmarketing', '#socialmediamarketing', '#contentcreation',
    '#businessgrowth', '#marketingtips', '#instatips', '#facebookads',
    '#onlinemarketing', '#creativeads', '#designinspiration',
    '#eventplanning', '#weddingideas', '#smallbusiness', '#ecommerce'
  ];

  const mockGalleryImages = [
    {
      id: 'gallery_img_1',
      url: 'https://picsum.photos/seed/1/300/200',
      type: 'image'
    },
    {
      id: 'gallery_img_2',
      url: 'https://picsum.photos/seed/2/300/200',
      type: 'image'
    },
    {
      id: 'gallery_img_3',
      url: 'https://picsum.photos/seed/3/300/200',
      type: 'image'
    },
    {
      id: 'gallery_img_4',
      url: 'https://picsum.photos/seed/4/300/200',
      type: 'image'
    },
    {
      id: 'gallery_img_5',
      url: 'https://picsum.photos/seed/5/300/200',
      type: 'image'
    },
    {
      id: 'gallery_img_6',
      url: 'https://picsum.photos/seed/6/300/200',
      type: 'image'
    },
    {
      id: 'gallery_img_7',
      url: 'https://picsum.photos/seed/7/300/200',
      type: 'image'
    },
    {
      id: 'gallery_vid_1',
      url: 'https://www.w3schools.com/html/mov_bbb.mp4',
      type: 'video'
    }
  ];
const aspectOptions = [
  { label: "Original", value: undefined, icon: <Expand size={16} /> },
  { label: "1:1", value: 1 / 1, icon: <Square size={16} /> },
  { label: "4:5", value: 4 / 5, icon: <RectangleVertical size={16} /> },
  { label: "16:9", value: 16 / 9, icon: <RectangleHorizontal size={16} /> },
];

  //--- Post Data State for Scheduling
  const [postData, setPostData] = useState({
    publishOption: 'Publish Now', // 'Publish Now' or 'Schedule for Later
    scheduleDate: '', // Selected date for scheduling
    scheduleHour: '12', // Selected hour for scheduling
    scheduleMinute: '00', // Selected minute for scheduling
    scheduleAmPm: 'AM', // AM/PM for scheduling
  });

  //--- Effects
  // Update ref for progress bar completion
  // useEffect(() => {
  //   completedBarCountRef.current = completedBarCount;
  // }, [completedBarCount]);

  completedBarCountRef.current = completedBarCount;

  //--- Handlers
  const handleEmojiClick = (emojiData) => {
    setDescription((prev) => prev + emojiData.emoji);
  };

  const handleEmojiClick1 = (emojiData) => {
    settwitterdescription((prev) => prev + emojiData.emoji);
  };

  const resetForm = () => {
    setPostType('Photos');
    setDescription('');
    setHashtags([]);
    setHashtagInput('');
    setShowHashtagSuggestions(false);
    setMediaFiles([]);
    setAudioFile(null);
    setTempSelectedMedia([]);
    setShowPreviewModal(false);
    setFeedbackMessage('');
    setCurrentStep(1);
    setCompletedBarCount(12);
    setPostData({
      publishOption: 'Publish Now',
      scheduleDate: '',
      scheduleHour: '12',
      scheduleMinute: '00',
      scheduleAmPm: 'AM'
    });
  };




  useEffect(() => {
    const handleKeyDown = (e) => {
      if (!showFullGallery) return;

      if (e.key === 'ArrowRight') {
        setCurrentIndex((prev) => (prev < galleryImages.length - 1 ? prev + 1 : 0));
      } else if (e.key === 'ArrowLeft') {
        setCurrentIndex((prev) => (prev > 0 ? prev - 1 : galleryImages.length - 1));
      } else if (e.key === 'Escape') {
        setShowFullGallery(false);
      }
    };

    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [showFullGallery, galleryImages.length]);

  const handleLinkedInPDFUpload = (e) => {
    const file = e.target.files[0];
    if (file && file.type === "application/pdf") {
      setLinkedInPDF(file);
      const newPDF = {
        id: uuidv4(),
        file,
        previewUrl: URL.createObjectURL(file),
        mediaType: "pdf",
        platform: "LinkedIn",
        title: linkedInPDFTitle,
      };

      setMediaFiles((prev) => [
        ...prev.filter((f) => !(f.platform === "LinkedIn" && f.mediaType === "pdf")),
        newPDF,
      ]);
    }
  };



  const handleHashtagInputChange = (e) => {
    const input = e.target.value;
    setHashtagInput(input);
    setShowHashtagSuggestions(input.length > 0);
  };

  const addHashtag = (tag) => {
    const formattedTag = tag.startsWith('#') ? tag : '#' + tag;
    if (!hashtags.includes(formattedTag)) {
      setHashtags((prev) => [...prev, formattedTag]);
      setHashtagInput('');
      setShowHashtagSuggestions(false);
    }
  };

  const removeHashtag = (tagToRemove) => {
    setHashtags((prev) => prev.filter((tag) => tag !== tagToRemove));
  };

  // const filteredHashtags = mockTrendingHashtags.filter(tag =>
  //   tag.toLowerCase().includes(hashtagInput.toLowerCase()) && !hashtags.includes(tag)
  // );

const handleNewMediaUpload = (e) => {
  const files = Array.from(e.target.files || []);
  if (!files.length) return;

  // LinkedIn image restriction: allow only 1 image
  if (mediaPlatformTab === "LinkedIn") {
    const existingImages = tempSelectedMedia.filter(
      (m) => m.platform === "LinkedIn" && m.mediaType === "image"
    );
    const newImageFiles = files.filter((file) => file.type.startsWith("image"));

    if (existingImages.length + newImageFiles.length > 1) {
      Swal.fire("Only 1 image allowed for LinkedIn", "", "warning");
      return;
    }
  }

  const newFiles = files.map((file) => ({
    id: uuidv4(),
    file,
    previewUrl: URL.createObjectURL(file),
    mediaType: file.type.startsWith("image") ? "image" : "video",
    platform: mediaPlatformTab,
  }));

  const imageFiles = newFiles.filter((file) => file.mediaType === "image");
  const videoFiles = newFiles.filter((file) => file.mediaType === "video");

  // ✅ Images: hamesha cropping queue mein bhejna
  if (imageFiles.length > 0) {
    setCroppingQueue((prev) => [...prev, ...imageFiles]);
  }

  // ✅ Videos: direct tempSelectedMedia mein
  if (videoFiles.length > 0) {
    setTempSelectedMedia((prev) => [...prev, ...videoFiles]);
  }

  e.target.value = "";
};




  const handleGalleryImageSelection = (galleryItem) => {
    setTempSelectedMedia(prev => {
      const isSelected = prev.some(item => item.id === galleryItem.id && item.type === 'url');
      if (isSelected) {
        return prev.filter(item => !(item.id === galleryItem.id && item.type === 'url'));
      } else {
        if (galleryItem.type === 'image' && (selectedPlatform === 'Instagram' || selectedPlatform === 'Twitter')) {
          setImageToCrop(galleryItem.url);
          setCropAspectRatio(selectedPlatform === 'Instagram' ? 4 / 5 : 16 / 9);
          setShowCropperModal(true);
          return prev;
        }
        return [...prev, {
          id: galleryItem.id,
          type: 'url',
          content: galleryItem.url,
          previewUrl: galleryItem.url,
          mediaType: galleryItem.type
        }];
      }
    });
  };
  // const isGalleryImageSelected = useCallback((galleryItemId) => {
  //   return tempSelectedMedia.some(item => item.id === galleryItemId && item.type === 'url');
  // }, [tempSelectedMedia]);

  const handleRemoveMedia = useCallback((id) => {
    setMediaFiles((prev) => prev.filter((item) => item.id !== id));
    setTempSelectedMedia((prev) => prev.filter((item) => item.id !== id));
  }, []);



  const openMediaGallery = () => setShowGalleryModal(true);

  const cancelMediaSelection = () => {
    setShowGalleryModal(false);
    setTempSelectedMedia([]);
    setMediaPlatformTab(null);
    // setSelectedAspectRatio(null);
  };



  const confirmMediaSelection = () => {
    var prevmediafiels = mediaFiles;
    for(var i = 0; i < tempSelectedMedia?.length;i++) {
      prevmediafiels.push(tempSelectedMedia[i]);
    }
    // prevmediafiels.push(tempSelectedMedia);
    setMediaFiles(prevmediafiels);
    cancelMediaSelection();
  };


  const handleAudioUpload = (e) => {
    const file = e.target.files[0];
    if (file && file.type.startsWith("audio/")) {
      setAudioFile(file);
      const url = URL.createObjectURL(file);
      setAudioUrl(url);
      console.log("Audio selected:", file.name);
    } else {
      Swal.fire('Invalid File', 'Please upload a valid audio file.', 'error');
    }
  };

  const handlePreviewPost = () => {
    setShowPreviewModal(true);
  };

  const handleProceed = () => {
    if (!description.trim()) {
      return Swal.fire('Missing Description', 'Please enter a post description.', 'warning');
    }
    if ((postType === 'Photos' || postType === 'Videos') && mediaFiles.length === 0) {
      return Swal.fire('No Media Selected', 'Please upload or select at least one media file.', 'warning');
    }
    setCurrentStep(2);
    setCompletedBarCount(52);
  };

  const handleDateTimeChange = (e) => {
    const { name, value } = e.target;
    setPostData((prev) => ({ ...prev, [name]: value }));
  };

  const handlePublishOptionChange = (option) => {
    setPostData((prev) => ({ ...prev, publishOption: option }));
  };

  const handleBack = () => {
    setCurrentStep(2);
  };

  const handletogglestep = (step) => {
    setCurrentStep(step);
  };

  const videoBase64 = (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file); // This returns base64 string with data:video/mp4;base64,
      reader.onload = () => resolve(reader.result);
      reader.onerror = (error) => reject(error);
    });
  };

  const filesToBase64 = async (mediafiles) => {
    const convertFile = (file) =>
      new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result.split(",")[1]); // Only pure Base64
        reader.onerror = (error) => reject(error);
      });

    var prevdata = mediafiles;
    var resultobj = {};
    for (var i = 0; i < prevdata?.length; i++) {
      if (resultobj[prevdata[i]?.platform]) {
        var prevarr = resultobj[prevdata[i]?.platform];
        if(prevdata[i]?.mediaType == "image") {
          const base64 = await convertFile(prevdata[i]?.content);
        var obj = {};
        obj['name'] = prevdata[i]?.content?.name;
        obj['base64image'] = base64;
        prevarr.push(obj);
        resultobj[prevdata[i]?.platform] = prevarr;
        } else {
          const base64videofile = await videoBase64(prevdata[i]?.file);
          var obj = {};
          obj['name'] = prevdata[i]?.file?.name;
          obj['base64video'] = base64videofile;
          prevarr.push(obj);
          resultobj[prevdata[i]?.platform] = prevarr;
        }
        
      } else {
        var newarr = [];
        if(prevdata[i]?.mediaType == "image") {
          const base64 = await convertFile(prevdata[i]?.content);
        var obj = {};
        obj['name'] = prevdata[i]?.content?.name;
        obj['base64image'] = base64;
        newarr.push(obj);
        resultobj[prevdata[i]?.platform] = newarr;
        } else {
          const base64videofile = await videoBase64(prevdata[i]?.file);
          var obj = {};
          obj['name'] = prevdata[i]?.file?.name;
          obj['base64video'] = base64videofile;
          newarr.push(obj);
          resultobj[prevdata[i]?.platform] = newarr;
        }
        
      }
    }
    return resultobj


    // const result = {};
    // for (const item of mediafiles) {
    //   const base64 = await convertFile(item.content);
    //   result[item.platform] = {
    //     name: item.content.name,
    //     base64image: base64
    //   };
    // }
    // return result;
  };

  const getScheduledTimestamp = (dateStr, hour, minute, ampm) => {
    let date = new Date(dateStr); // e.g. "2025-08-02"

    let h = parseInt(hour);
    if (ampm === "PM" && h !== 12) h += 12;
    if (ampm === "AM" && h === 12) h = 0;

    date.setHours(h, parseInt(minute), 0, 0);

    // Convert to seconds (UTC timestamp)
    return Math.floor(date.getTime() / 1000);
  }


  const handleFinalAction = async () => {
    setfinalloading(true);
    var selectedpagesss = selectedPagesRef.current;
    console.log('selectedpagesss >>', selectedpagesss);
    var prevdescription = description;
    if (issamehashtag) {
      // if Common hashtags
      if (hashtagInput) {
        prevdescription = `${description}\n\n${hashtagInput.join(' ')}`
      } else {
        prevdescription = description;
      }
    } else {
      // if Different common hashtags
      prevdescription = description;
    }
    var data = {
      type: postType,
      postname: postname,
      description: prevdescription,
      twitterdescription: isseperatefortwittercheckbox ? twitterdescription : description,
      issamehashtag: issamehashtag,
      allhashtags: hashtagInput ? hashtagInput?.join(' ') : "",
      publishtype: postData.publishOption,
      scheduledateandtime: postData.publishOption == "Schedule for Later" ?
        getScheduledTimestamp(
          postData.scheduleDate,
          postData.scheduleHour,
          postData.scheduleMinute,
          postData.scheduleAmPm
        )
        : "",
      mediafilesarr: "",
      selectedpages: selectedPagesRef.current
    }

    console.log('mediaFiles >>', mediaFiles);
    try {
      const formattedImagesObj = await filesToBase64(mediaFiles);
      console.log("Formatted Output:", formattedImagesObj);
      data["mediafilesarr"] = formattedImagesObj;
    } catch (err) {
      console.error("Error converting files:", err);
    }
    console.log('data >>', data);

    const headers = {
      headers: {
        Authorization: `Bearer ${userdata?.token}`,
      },
    };

    const res = await axios.post(apiUrl + "newcreatepostfbv2", data, headers);
    setfinalloading(false);

    if (res.data?.status === "success") {
      setfinalloading(false);
      Swal.fire('Post Published!', 'Your post has been published successfully.', 'success');
      resetForm();
      setCurrentStep(1);
      setCompletedBarCount(12);
      navigate('/admin/all-posts');
    } else {
      setfinalloading(false);
      Swal.fire('', 'Something went wrong, Please try again', 'warning');
    }
    setfinalloading(false);




    // if (postData.publishOption === 'Schedule for Later' && !postData.scheduleDate) {
    //   return Swal.fire('Missing Date', 'Please select a date and time for scheduling.', 'warning');
    // }

    // const scheduledTime = `${postData.scheduleDate} ${postData.scheduleHour}:${postData.scheduleMinute} ${postData.scheduleAmPm}`;

    // if (postData.publishOption === 'Publish Now') {
    //   Swal.fire('Post Published!', 'Your post has been published successfully.', 'success');

    //   navigate('/admin/postdetails'); // ✅ redirect after publish
    // } else {
    //   Swal.fire('Post Scheduled!', `Your post is scheduled for ${scheduledTime}`, 'success');
    // }

    // resetForm();
    // setCurrentStep(1);
    // setCompletedBarCount(12);
  };

  const handleHashtagUpdate = (index, value) => {
    console.log('index >>', index);
    console.log('value >>', value);
    var prevdata = selectedPagesRef?.current;
    prevdata[index].selectedhashtags = value.join(",");
    setSelectedPages(prevdata);
    setforcestateupdate(!forcestateupdate);
    // const input = e.target.value;
    // setHashtagInput(input);
    // setShowHashtagSuggestions(input.length > 0);
  };

  const handleselctedtag = useCallback((t) => {
    console.log('t >>', t)
  }, [])

  const handleclicktagsmodal = (index) => {
    setselectedfortagmodal(index);
    setTimeout(() => {
      setshowtrendingtagsmodal(true);
    }, 1000);
  }

  const handlehashtagscopy = (data) => {
    const arrayAsString = JSON.stringify(data); // or myArray.join(", ")
    navigator.clipboard.writeText(data)
      .then(() => {
        // alert("Array copied to clipboard!");
        toast.success("Hashtags copied!");
      })
      .catch(err => {
        toast.error("Failed!! Try again");
      });
  }

  const [selectedplatforminside, setselectedplatforminside] = useState("");
  const selectedplatforminsideRef = useRef(null);
  selectedplatforminsideRef.current = selectedplatforminside;

  console.log('selectedplatforminsideRef.current >>', selectedplatforminsideRef.current)

  const HashTagsSection = () => {
    var platformsdata = selectedPagesRef.current;
    console.log('HashTagsSection platformsdata >>', platformsdata);
    var platformsobj = {};

    for (var i = 0; i < platformsdata?.length; i++) {
      if (platformsobj[platformsdata[i]?.platform]) {
        var prevarr = platformsobj[platformsdata[i]?.platform];
        prevarr.push(platformsdata[i]);
        platformsobj[platformsdata[i]?.platform] = prevarr;
      } else {
        var newarr = [];
        newarr.push(platformsdata[i]);
        platformsobj[platformsdata[i]?.platform] = newarr;
      }
    }
    console.log('platformsobj >>', platformsobj);

    return (
      <>
        {issamehashtag ? (
          <>
            <div className="hashtag-input-main-container">
              <div className="hashtag-input-container">
                <TagsInput
                  value={hashtagInput}
                  onChange={(options) => {
                    setHashtagInput(options);
                  }}
                  placeholder={"Enter HashTags e.g #Hello #World"}
                  inputProps={{
                    className: "react-tagsinput-input",
                    placeholder: "",
                  }}
                  className="form-control tagsinputbox1"
                />
              </div>
            </div>
          </>
        ) : // Multiple Hashtags
          platformsdata?.length > 0 ? (
            <div className="newhashtag mt-3">
              <div className="newhashtagsarr">
                <select
                  className="form-control hashtagdropdown"
                  value={selectedplatforminside}
                  onChange={(t) => {
                    setselectedplatforminside(t.target.value);
                  }}
                >
                  <option value={""} selected>
                    Select Platform
                  </option>
                  {
                    Object.keys(platformsobj)?.length > 0 ?
                      Object.keys(platformsobj)?.map((item, index) => {
                        return (
                          <option value={item}>{item}</option>
                        )
                      }) : null
                  }
                </select>
                {
                  selectedplatforminside ?
                    <div className="mt-2">
                      <label
                        htmlFor="hashtags"
                        className="form-label"
                        style={{ cursor: "pointer" }}
                        onClick={() => {
                          handleclicktagsmodal(selectedplatforminside);
                        }}
                      >
                        Trending on {selectedplatforminside}
                      </label>
                    </div> : null
                }

              </div>
              {/* Individual Hashtag row */}
              {
                selectedplatforminside ?
                  <div className='hastag-dropdown-newrow'>
                    {
                      platformsdata?.length > 0 ?
                        platformsdata?.map((item, index) => {
                          if (item?.platform == selectedplatforminside) {
                            var tagsinputarr = item?.selectedhashtags ? item?.selectedhashtags?.split(",") : [];
                            return (
                              <div
                                key={index}
                                className={index == 0 ? "mt-3" : "mt-3"}
                              >
                                <div className="d-flex justify-content-between">
                                  <label htmlFor="hashtags" className="form-label">
                                    {/* Hashtags for {item?.platform} ({item?.name}): */}
                                    Hashtags for ({item?.name}) :
                                  </label>
                                </div>
                                <div className="hashtag-input-main-container">
                                  <div className="hashtag-input-container">
                                    <TagsInput
                                      value={tagsinputarr}
                                      onChange={(options) => {
                                        handleHashtagUpdate(index, options);
                                      }}
                                      placeholder={"Enter HashTags e.g #Hello #World"}
                                      inputProps={{
                                        className: "react-tagsinput-input",
                                        placeholder: "",
                                      }}
                                      className="form-control tagsinputbox1"
                                    />
                                  </div>
                                  <div className="" style={{ marginLeft: 20 }}>
                                    <FontAwesomeIcon
                                      icon={faCopy}
                                      fontSize={25}
                                      style={{
                                        marginLeft: 15,
                                        marginTop: 20,
                                        cursor: "pointer",
                                      }}
                                      onClick={() => { handlehashtagscopy(tagsinputarr) }}
                                    />
                                  </div>
                                </div>
                                {/* for linkdin */}
                                {
                                  item?.platform == "LinkedIn" ?
                                    <div className="mt-3 mb-3">
                                      {item?.platform == "LinkedIn" ? (
                                        <>
                                          <label htmlFor="audio-upload" className="form-label">
                                            Attach Pdf - Linkedin ({item?.name}):
                                          </label>
                                          <Paperclip size={20} style={{ color: "#6b7280" }} />
                                          <input
                                            type="file"
                                            accept="application/pdf"
                                            className="post-details-file-input"
                                            onChange={handleLinkedInPDFUpload}
                                          />
                                          {linkedInPDF && (
                                            <div className="form-group mt-2">
                                              <label>Slide Title for LinkedIn PDF:</label>
                                              <input
                                                type="text"
                                                className="form-input"
                                                placeholder="Enter slide title..."
                                                value={linkedInPDFTitle}
                                                onChange={(e) => setLinkedInPDFTitle(e.target.value)}
                                              />
                                            </div>
                                          )}
                                        </>
                                      ) : null}

                                    </div> : null
                                }
                              </div>
                            );
                          }

                        })
                        : null
                    }

                  </div> : null
              }
            </div>
          ) : null}
      </>
    );
  }

  const fetchallplatforms = async () => {
    setShowLoading(true);
    const headers = {
      headers: {
        'Content-Type': 'application/json',
        Authorization: 'Bearer ' + userdata?.token,
      },
    };

    try {
      const res = await axios.get(apiUrl + 'getallplatformdetails', headers);
      if (res.data.status === 'success') {
        // const prevdata = sampledata;
        var prevfetcheddata = res?.data?.data;
        var keysoffetcheddata = Object.keys(prevfetcheddata);
        var newobj = {};
        for (var i = 0; i < Object.keys(keysoffetcheddata)?.length; i++) {
          var iconname = "";
          if (keysoffetcheddata[i] == "Facebook") {
            iconname = Facebook;
          } else if (keysoffetcheddata[i] == "LinkedIn") {
            iconname = Linkedin;
          } else if (keysoffetcheddata[i] == "Instagram") {
            iconname = Instagram;
          } else if (keysoffetcheddata[i] == "Twitter") {
            iconname = Twitter;
          } else if (keysoffetcheddata[i] == "Youtube") {
            iconname = Youtube;
          }

          newobj[keysoffetcheddata[i]] = {
            icon: iconname,
            color: "#1877F2",
            pagelist: prevfetcheddata[keysoffetcheddata[i]]?.pagesarr ? JSON.parse(prevfetcheddata[keysoffetcheddata[i]].pagesarr) : [],
            accesstoken: prevfetcheddata[keysoffetcheddata[i]]?.accesstoken,
            accountname: prevfetcheddata[keysoffetcheddata[i]]?.accountname
          }
        }
        console.log('newobj >>', newobj);
        setallpagesdata(newobj);
      } else if (res.data.message === 'invalid user') {
        dispatch({ type: 'userdata', payload: {} });
        navigate('/login');
      } else {
        Swal.fire({
          text: res.data.message,
          icon: 'error',
          width: '350px',
          confirmButtonText: 'Ok',
          confirmButtonColor: 'rgb(59, 151, 196)',
          customClass: { popup: 'small-icon-alert' },
        });
      }
    } catch (err) {
      alert(err.message);
    } finally {
      setShowLoading(false);
    }
  }

  useEffect(() => {
    if (description) {
      console.log('checklength >>', description?.length);
      if (description?.length > 280) {
        if (istwitterselected) {
          setshowtwitterwarning(true)
        } else {

        }
      }
    }
  }, [description])

  // --- Image Cropping Handlers ---
  const onCropComplete = useCallback((croppedArea, croppedAreaPixels) => {
    setCroppedPixels(croppedAreaPixels);
  }, []);

  const handleApplyCrop = useCallback(async () => {
    try {
      const croppedImageBlob = await getCroppedImg(imageToCrop, croppedPixels);
      const croppedFile = new File([croppedImageBlob], `cropped_${Date.now()}.png`, {
        type: 'image/png',
      });

      setTempSelectedMedia((prev) => [
        ...prev,
        {
          id: croppedFile.name + Date.now(),
          type: 'file',
          content: croppedFile,
          previewUrl: URL.createObjectURL(croppedFile),
          mediaType: 'image',
          platform: croppedFileMeta?.platform || mediaPlatformTab,
        },
      ]);

      // Clear and allow next crop to start
      setImageToCrop(null);
      setCrop({ x: 0, y: 0 });
      setZoom(1);
      setShowCropperModal(false);
    } catch (e) {
      console.error("Error applying crop:", e);
      Swal.fire('Error', 'Failed to crop image. Please try again.', 'error');
    }
  }, [imageToCrop, croppedPixels, croppedFileMeta, mediaPlatformTab]);


  const handleCancelCrop = useCallback(() => {
    setImageToCrop(null);
    setCrop({ x: 0, y: 0 });
    setZoom(1);
    setShowCropperModal(false);
  }, []);

useEffect(() => {
  if (!imageToCrop && croppingQueue.length > 0) {
    const next = croppingQueue[0];

    if (next.mediaType !== "image") {
      // Agar galti se koi video aa gaya ho queue mein, direct add karo aur skip karo crop
      setTempSelectedMedia((prev) => [...prev, next]);
      setCroppingQueue((q) => q.slice(1));
      return;
    }

    // setCropAspectRatio(selectedAspectRatio);
    setImageToCrop(next.previewUrl);
    setCroppedFileMeta(next);
    setCroppingQueue((q) => q.slice(1));
    setShowCropperModal(true);
  }
}, [imageToCrop, croppingQueue]);



  // Fetch data from backend
  useEffect(() => {
    fetchallplatforms();
  }, [])

  // console.log('selectedPages >>', selectedPages);

  // --- Render JSX ---
  return (
    <div className="webadmin-modalmainbody">
    {/* <Overlay showloader={finalloading} /> */}
      {/* Progress Bar Section */}
      <div className="progressbar-maindiv1">
        <div className="progressbar-maindiv">
          <ProgressBar
            completed={completedBarCountRef.current}
            isLabelVisible={false}
            bgColor="#3F9BD3"
          />
        </div>
      </div>

      <div className="progressbar-numberdiv">
        <div
          className="step1div"
          onClick={() => {
            // handletogglestep(1);
            // setCompletedBarCount(12);
          }}
        >
          <div className="step1divround">
            <p>1</p>
          </div>
        </div>

        <div
          className="step1div"
          onClick={() => {
            // handletogglestep(2);
            // setCompletedBarCount(52);
          }}
        >
          <div className="step1divround">
            <p>2</p>
          </div>
        </div>

        <div
          className="step1div"
          onClick={() => {
            // handletogglestep(3);
            // setCompletedBarCount(88);
          }}
        >
          <div className="step1divround">
            <p>3</p>
          </div>
        </div>
        {/* Optional Step 4 if needed */}
        {/* <div className="step1div" onClick={() => setcompletedbarcount(87)}>
          <div className="step1divround"><p>4</p></div>
        </div> */}
      </div>

      <div className="progressbar-numberdiv progressbar-numberdiv1">
        <div
          className="step1div"
          onClick={() => {
            // handletogglestep(1);
            // setcompletedbarcount(12);
          }}
        >
          <p className="progressbar-labeldiv">Platforms</p>
        </div>

        <div
          className="step1div"
          onClick={() => {
            // handletogglestep(2);
            // setcompletedbarcount(52);
          }}
        >
          <p className="progressbar-labeldiv">Post Content</p>
        </div>

        <div
          className="step1div"
          onClick={() => {
            // handletogglestep(3);
            // setcompletedbarcount(88);
          }}
        >
          <p className="progressbar-labeldiv">Schedule</p>
        </div>
      </div>

      {/* Main Content Area based on currentStep */}
      <div className="progress-body-div">
        {/* Step 1: Select Platforms */}
        {currentStep === 1 ? (
          <div className="post-page-wrapper">
            <div className="fb-platform-step-wrapper post-page-container post-form-card">
              <h4 className="form-title">Select Platforms</h4>
              <div className="fb-platform-selection-box">
                {/* Left: Platform Selector */}
                <div className="fb-platform-card">
                  <h3 className="fb-platform-subheading">
                    Social Media Platforms
                  </h3>
                  <div className="fb-platform-list">
                    {Object.keys(allpagesdataRef.current)?.length > 0
                      ? Object.keys(allpagesdataRef.current)?.map(
                        (item, index) => {
                          const ShowPlatform =
                            allpagesdataRef.current[item]?.icon;
                          return (
                            <div key={index}>
                              <button
                                onClick={() => setSelectedPlatform(item)}
                                className={`fb-platform-tab-button ${selectedPlatformRef.current === item
                                  ? "active"
                                  : ""
                                  }`}
                              >
                                <>
                                  <ShowPlatform size={18} />
                                  {item}
                                </>
                              </button>
                            </div>
                          );
                        }
                      )
                      : null}
                  </div>
                </div>
                {/* Right: Pages/Accounts */}
                <div className="fb-platform-card">
                  <h3 className="fb-platform-subheading">
                    {selectedPlatform} Pages/Accounts
                  </h3>
                  <ul className="fb-account-list">
                    {Object.keys(allpagesdataRef.current)?.length > 0 &&
                      selectedPlatform
                      ? allpagesdataRef.current[selectedPlatform]?.pagelist.map(
                        (item, index) => {
                          // console.log('item >>', item);
                          return (
                            <li key={index} className="fb-account-list-item">
                              <label className="fb-checkbox-wrapper">
                                <input
                                  type="checkbox"
                                  checked={
                                    item?.isselected == "true" ? true : false
                                  }
                                  onChange={() => {
                                    handletoggleselectedpages(
                                      selectedPlatform,
                                      index,
                                      item?.isselected
                                    );
                                  }}
                                />
                                <span className="fb-custom-checkbox" />
                                <span>
                                  {item?.name}
                                  {/* <span
                              className="fb-account-type">({page.type})</span> */}
                                </span>
                              </label>
                            </li>
                          );
                        }
                      )
                      : null}
                  </ul>
                </div>
              </div>
              <div className="fb-platform-step-actions">
                <button
                  onClick={() => {
                    setCurrentStep(2);
                    setCompletedBarCount(52);
                  }}
                  className="navigation-button"
                  disabled={selectedPages.length === 0}
                >
                  Next →
                </button>
                <div className="fb-selected-summary-box">
                  Selected Pages:
                  <strong>{selectedPages.length}</strong>
                </div>
              </div>
            </div>
          </div>
        ) : currentStep === 2 ? (
          // Step 2: Create New Post
          <div className="progress-body-div1">
            {currentStep === 2 && (
              <div className="post-page-wrapper">
                <div className="post-page-container">
                  <div className="post-form-card">
                    <h2 className="form-title">Create New Post</h2>
                    {/* Post Type Selection - Pill-shaped buttons, smaller icons */}
                    <div className="form-group">
                      <label className="form-label">Post Type:</label>
                      <div className="post-type-grid">
                        {["Photos", "Videos", "Feed", "Combined"].map((type) => (
                          <label
                            key={type}
                            className={`post-type-option ${postType === type ? "selected" : ""
                              }`}
                          >
                            <input
                              type="radio"
                              name="postType"
                              value={type}
                              checked={postType === type}
                              onChange={(e) => setPostType(e.target.value)}
                            />
                            {type === "Photos" && (
                              <ImageIcon size={20} className="lucide-icon" />
                            )}
                            {type === "Videos" && (
                              <VideoIcon size={20} className="lucide-icon" />
                            )}
                            {type === "Feed" && (
                              <Rss size={20} className="lucide-icon" />
                            )}
                            {type === "Combined" && (
                              <>
                                <ImageIcon size={18} className="lucide-icon" />
                                <VideoIcon size={20} className="lucide-icon" />
                              </>
                            )}
                            <span>{type}</span>
                          </label>
                        ))}
                      </div>
                    </div>
                    {/* Post Name (Input Field) */}
                    <div className="form-group">
                      <label htmlFor="posttext" className="form-label">
                        Post Name:
                      </label>
                      <input
                        type='text'
                        value={postname}
                        onChange={(t) => {
                          setpostname(t.target.value);
                        }}
                        className="form-input"
                        placeholder="Enter post Name..."

                      ></input>
                    </div>
                    {/* Description with Emoji Picker */}
                    <div className="form-group">
                      <label htmlFor="description" className="form-label">
                        Description:
                      </label>
                      <div className="emoji-textarea-wrapper">
                        <textarea
                          type="text"
                          id="description"
                          className="form-textarea"
                          placeholder="Enter post description..."
                          value={description}
                          onChange={(e) => setDescription(e.target.value)}
                        ></textarea>
                        <button
                          type="button"
                          className="emoji-button"
                          onClick={() => setShowEmojiPicker((prev) => !prev)}
                        >
                          😊
                        </button>
                        {showEmojiPicker && (
                          <div className="emoji-picker-container">
                            <EmojiPicker onEmojiClick={handleEmojiClick} />
                          </div>
                        )}
                      </div>
                      {
                        showtwitterwarning ?
                          <>
                            <div className="twitter-warning-div">
                              <TriangleAlert
                                size={18}
                                style={{ color: "#333", marginRight: 5 }}
                              />
                              <p>
                                Description length is exceeding twitter tweet limit, do you want seperate description for twitter ?</p>
                              <input
                                type="checkbox"
                                className='twittercheckbox'
                                checked={isseperatefortwittercheckbox}
                                onChange={() => {
                                  setisseperatefortwittercheckbox(!isseperatefortwittercheckbox);
                                }}
                              />
                            </div>
                            {
                              isseperatefortwittercheckbox ?
                                <>
                                  <label htmlFor="description" className="form-label">
                                    Twitter Description
                                  </label>
                                  <div className="emoji-textarea-wrapper">
                                    <textarea
                                      type="text"
                                      id="description"
                                      className="form-textarea"
                                      placeholder="Enter post description..."
                                      value={twitterdescription}
                                      onChange={(e) => settwitterdescription(e.target.value)}
                                    ></textarea>
                                    <button
                                      type="button"
                                      className="emoji-button"
                                      onClick={() => setShowEmojiPicker1((prev) => !prev)}
                                    >
                                      😊
                                    </button>
                                    {showEmojiPicker1 && (
                                      <div className="emoji-picker-container">
                                        <EmojiPicker onEmojiClick={handleEmojiClick1} />
                                      </div>
                                    )}
                                  </div>
                                </> : null
                            }
                          </>


                          : null
                      }

                    </div>
                    {/* Hashtags with Suggestions */}
                    <div
                      className="form-group mt-2"
                      style={{ position: "relative" }}
                    >
                      <div className="hastaglabelrow">
                        <label htmlFor="hashtags" className="form-label">
                          Hashtags (e.g., #marketing #digital):
                        </label>
                        <div className="d-flex" style={{ marginLeft: "auto" }}>
                          <input
                            type="checkbox"
                            checked={issamehashtag}
                            className="hastagcheckbox"
                            onChange={() => {
                              setissamehashtag(!issamehashtag);
                              //  handletoggleselectedpages(selectedPlatform, index, item?.isselected)
                            }}
                          />
                          <label htmlFor="hashtags" className="form-label">
                            Same HashTags on All Platforms
                          </label>
                        </div>
                      </div>

                      {<HashTagsSection />}
                    </div>

                    {/* {selectedPagesRef?.current?.map((item, index) => {
                      // console.log("for pdf >>", item);
                      return (
                        <div className="mt-5 mb-3">
                          {item?.platform == "LinkedIn" ? (
                            <>
                              <label htmlFor="audio-upload" className="form-label">
                                Attach Pdf - Linkedin ({item?.name}):
                              </label>
                              <Paperclip size={20} style={{ color: "#6b7280" }} />
                              <input
                                type="file"
                                accept="application/pdf"
                                className="post-details-file-input"
                                onChange={handleLinkedInPDFUpload}
                              />
                              {linkedInPDF && (
                                <div className="form-group mt-2">
                                  <label>Slide Title for LinkedIn PDF:</label>
                                  <input
                                    type="text"
                                    className="form-input"
                                    placeholder="Enter slide title..."
                                    value={linkedInPDFTitle}
                                    onChange={(e) => setLinkedInPDFTitle(e.target.value)}
                                  />
                                </div>
                              )}
                            </>
                          ) : null}

                        </div>
                      );
                    })} */}
                    <br />

                    {/* Conditional Media Upload/Gallery */}
                    {/* Media Gallery Modal */}
                    <div>
                      {/* Trigger Upload */}
                  {postType !== "Feed" && (
  <>
    <button className="media-upload-button" onClick={openMediaGallery}>
      <Upload size={20} /> Select Media
    </button>
  </>
)}
{
  console.log('mediaFiles middle >>', mediaFiles)
}


                      {/* Show grouped preview summary below Select Media */}
                     {postType !== "Feed" && (
  <>
    {[...new Set(mediaFiles.map(m => m.platform))].map((platform) => (
      <div className="media-preview-group" key={platform}>
        <div className="media-preview-heading">
          {platform} ({mediaFiles.filter(f => f.platform === platform).length} selected)
        </div>
        <div className="media-slider-wrapper">
          <div className="media-slider">
            {mediaFiles
              .filter((f) => f.platform === platform)
              .map((media, index) => (
                <div className="media-thumbnail-wrapper" key={media.id}>
                  {media.mediaType === "image" ? (
                    <img src={media.previewUrl} alt="media" />
                  ) : (
                    <video
                      src={media.previewUrl}
                      controls
                      width="100%"
                      style={{ maxHeight: "120px", objectFit: "cover" }}
                    />
                  )}
                  <button
                    className="media-remove-btn"
                    onClick={() => handleRemoveMedia(media.id)}
                  >
                    ×
                  </button>
                </div>
              ))}
          </div>
        </div>
      </div>
    ))}
  </>
)}



                      {/* Modal */}
                      {showGalleryModal && (
                        <div className="modal-overlay animate-fade-in">
                          <div className="modal-content gallery-modal-content animate-zoom-in media-platform">
                            <div className="gallery-modal-header">
                              <h3>Select Media</h3>
                              <button
                                onClick={cancelMediaSelection}
                                className="modal-close-button"
                              >
                                <XCircle size={28} />
                              </button>
                            </div>

                            {/* Platform Tabs */}
                            <label className="form-label">Choose Platform:</label>
                            <div className="tab-button-group">
                              {[...new Set(selectedPages.map((p) => p.platform))].map((platform) => (
                                <button
                                  key={platform}
                                  className={`tab-button ${mediaPlatformTab === platform ? "active" : ""}`}
                                  onClick={() => {
                                    setMediaPlatformTab(platform);
                                   
                                  }}
                                >
                                  {platform}
                                </button>
                              ))}
                            </div>

                            {/* Aspect Ratios */}
                            {/* {mediaPlatformTab && (
                              <>
                                <label className="form-label">Choose Aspect Ratio:</label>
                                <div className="ratio-button-group">
                                  {aspectRatios[mediaPlatformTab]?.map((option) => (
                                    <button
                                      key={option.label}
                                      onClick={() => setSelectedAspectRatio(option.value)}
                                      className={`ratio-button ${selectedAspectRatio === option.value ? "active" : ""
                                        }`}
                                    >
                                      {option.label}
                                    </button>
                                  ))}
                                </div>
                              </>
                            )} */}

                            {/* Upload input */}
                            {mediaPlatformTab &&  (
                              <>
                                <label className="form-label">Upload Image or Video:</label>
                                <div className="gallery-upload-input-wrapper">
                                  <FileUp size={20} className="lucide-icon" />
                                  <input
                                    type="file"
                                    id="modal-media-upload"
                                    className="gallery-upload-file-input"
                                    multiple
                                    accept="image/*,video/*"
                                    onChange={handleNewMediaUpload}
                                  />
                                </div>
                              </>
                            )}

                            {/* Preview in Modal */}
                         {[...new Set(tempSelectedMedia.map(m => m.platform))].map((platform) => (
  <div className="media-preview-group" key={platform}>
    <div className="media-preview-heading">
      {platform} ({mediaFiles.filter(f => f.platform === platform).length} selected)
    </div>
    <div className="media-slider-wrapper">
      <div className="media-slider">
        {tempSelectedMedia
          .filter((media) => media.platform === platform)
          .map((media) => (
            <div className="media-thumbnail-wrapper" key={media.id}>
              {media.mediaType === "image" ? (
                <img src={media.previewUrl} alt="media" />
              ) : (
                <video
                  src={media.previewUrl}
                  controls
                  width="100%"
                  style={{ maxHeight: "120px", objectFit: "cover" }}
                />
              )}
              <button
                className="media-remove-btn"
                onClick={() => handleRemoveMedia(media.id)}
              >
                ×
              </button>
            </div>
          ))}
      </div>
    </div>
  </div>
))}




                            {/* Actions */}
                            <div className="modal-actions">
                              <button
                                onClick={cancelMediaSelection}
                                className="modal-action-button cancel"
                              >
                                Cancel
                              </button>
                              <button
                                onClick={confirmMediaSelection}
                                className="modal-action-button confirm"
                               disabled={!mediaPlatformTab || tempSelectedMedia.length === 0
                                }
                              > 
                                Confirm Selection
                              </button>
                            </div>
                          </div>
                        </div>
                      )}
                    </div>
                    {/* Audio Trim Options (conditional) */}
                    {audioFile && (
                      <div className="post-details-audio-trim">
                        <audio
                          controls
                          src={URL.createObjectURL(audioFile)}
                          className="post-details-audio-player"
                          onLoadedMetadata={(e) => setAudioDuration(e.target.duration)}
                          onTimeUpdate={(e) => {
                            const current = e.target.currentTime;
                            if (current > trimEnd) e.target.pause();
                          }}
                          onPlay={(e) => {
                            if (e.target.currentTime < trimStart) {
                              e.target.currentTime = trimStart;
                            }
                          }}
                        />

                        <div className="post-details-trim-options">
                          <label>
                            <input
                              type="radio"
                              value={30}
                              checked={trimOption === 30}
                              onChange={() => {
                                setTrimOption(30);
                                setTrimEnd(
                                  Math.min(trimStart + 30, audioDuration)
                                );
                              }}
                            />
                            30 seconds
                          </label>
                          <label>
                            <input
                              type="radio"
                              value={60}
                              checked={trimOption === 60}
                              onChange={() => {
                                setTrimOption(60);
                                setTrimEnd(
                                  Math.min(trimStart + 60, audioDuration)
                                );
                              }}
                            />
                            1 minute
                          </label>
                        </div>
                        <div className="post-details-trim-slider">
                          <label>Select Start Time:</label>
                          <input
                            type="range"
                            min="0"
                            max={audioDuration - trimOption}
                            value={trimStart}
                            onChange={(e) => {
                              const start = parseInt(e.target.value);
                              setTrimStart(start);
                              setTrimEnd(start + trimOption);
                            }}
                          />
                          <p className="post-details-trim-range">
                            Trimming from
                            <strong>{formatTime(trimStart)}</strong> to
                            <strong>{formatTime(trimEnd)}</strong>
                          </p>
                        </div>
                      </div>
                    )}








                    {/* Preview Button */}
                    <button
                      onClick={handlePreviewPost}
                      className="preview-button"
                    >
                      <Eye size={20} /> Preview Post
                    </button>
                    {/* Navigation Buttons */}
                    <div className="fb-platform-step-actions">
                      <button
                        onClick={() => {
                          setCurrentStep(1);
                          setCompletedBarCount(12);
                        }}
                        className="fb-step-button fb-back"
                      >
                        ← Back
                      </button>
                      <button
                        onClick={() => {
                          setCurrentStep(3);
                          setCompletedBarCount(88);
                        }}
                        className="navigation-button"
                      >
                        Next →
                      </button>
                    </div>
                    {/* Post Preview Modal */}
                    {showPreviewModal && (
                      <div className="post-preview">
                        <div className="post-preview-modal-content">
                          <div className="post-preview-modal-header">
                            <h3 className="post-preview-modal-title">
                              Post Preview
                            </h3>
                            <button
                              onClick={() => setShowPreviewModal(false)}
                              className="post-preview-modal-close-button"
                            >
                              <XCircle size={28} />
                            </button>
                          </div>
                          <div className="post-preview-tab-selector">
                            {[...new Set(selectedPages.map((p) => p.platform))].map((platform) => (
                              <button
                                key={platform}
                                className={`post-preview-tab-button
                                    ${selectedPlatform === platform
                                    ? "active"
                                    : ""
                                  }`}
                                onClick={() => setSelectedPlatform(platform)}
                              >
                                {platform}
                              </button>
                            ))}
                          </div>

                          <div
                            className={`post-preview-platform-preview-box
                                ${selectedPlatform.toLowerCase()}-preview-box`}
                          >

                            {/* === FACEBOOK PREVIEW === */}
                            {selectedPlatform === "Facebook" && (
                              <div className="post-preview-facebook-card">
                                <div className="post-preview-fb-header">
                                  <UserCircle size={40} />
                                  <div>
                                    <div className="post-preview-fb-page-name">FB Page</div>
                                    <div className="post-preview-fb-meta">Just now <Globe size={12} /></div>
                                  </div>
                                </div>

                                <p className="post-preview-fb-description">{description}</p>

                                {/* ✅ IMAGE PREVIEW SECTION */}
                             <div className="fb-grid-preview">
  {mediaFiles
    .filter(f => f.platform === "Facebook")
    .slice(0, 3)
    .map((img, i, arr) => {
      const fbImages = mediaFiles.filter(f => f.platform === "Facebook");
      const extraCount = fbImages.length - 3;

      return (
        <div
          key={i}
          className="fb-grid-image"
          onClick={() => {
            setGalleryImages(fbImages);
            setCurrentIndex(i);
            setShowFullGallery(true);
          }}
        >
          {img.mediaType === "image" ? (
            <img src={img.previewUrl} alt={`img-${i}`} />
          ) : (
            <video
              src={img.previewUrl}
              controls
              width="100%"
              style={{ maxHeight: "200px", objectFit: "cover" }}
            />
          )}

          {i === arr.length - 1 && extraCount > 0 && (
            <div className="fb-more-overlay">+{extraCount}</div>
          )}
        </div>
      );
    })}
</div>


                                <div className="post-preview-fb-actions">
                                  <span><ThumbsUp size={16} /> Like</span>
                                  <span><MessageCircle size={16} /> Comment</span>
                                  <span><Share2 size={16} /> Share</span>
                                </div>
                                <div className="post-preview-fb-date">July 25, 2025</div>
                              </div>
                            )}

                            {showFullGallery && (
                              <div className="fb-gallery-overlay" onClick={() => setShowFullGallery(false)}>
                                <div className="fb-gallery-content" onClick={(e) => e.stopPropagation()}>
                                  <button className="fb-gallery-close" onClick={() => setShowFullGallery(false)}>×</button>

                                  {galleryImages.map((img, index) => (
                                    <div key={index} className="fb-gallery-post-item">
                                      <img src={img.previewUrl} alt={`img-${index}`} />
                                      <div className="fb-gallery-actions">
                                        <span><ThumbsUp size={16} /> Like</span>
                                        <span><MessageCircle size={16} /> Comment</span>
                                        <span><Share2 size={16} /> Share</span>
                                      </div>
                                    </div>
                                  ))}
                                </div>
                              </div>
                            )}



                            {/* === INSTAGRAM PREVIEW === */}
                            {selectedPlatform === "Instagram" && (
                              <div className="post-preview-insta-card">
                                <div className="post-preview-insta-header">
                                  <UserCircle size={36} />
                                  <span className="post-preview-insta-username">insta_user</span>
                                </div>

                                <MediaPreviewSlider mediaFiles={mediaFiles.filter(f => f.platform === "Instagram")} />

                                <p className="post-preview-insta-description">{description}</p>

                                <div className="post-preview-insta-tags">
                                  {hashtags.map((tag, i) => (
                                    <span key={i}>#{tag}</span>
                                  ))}
                                </div>

                                <div className="post-preview-insta-actions">
                                  <span><Heart size={16} /> Like</span>
                                  <span><MessageCircle size={16} /> Comment</span>
                                  <span><Share2 size={16} /> Share</span>
                                </div>
                                <div className="post-preview-insta-date">July 18, 2025</div>
                              </div>
                            )}

                            {/* === LINKEDIN PREVIEW === */}
                            {/* === LINKEDIN PREVIEW === */}
                            {selectedPlatform === "LinkedIn" && (
                              <div className="post-preview-linkedin-card">
                                <div className="post-preview-li-header">
                                  <UserCircle size={40} />
                                  <div>
                                    <div className="post-preview-li-company">Company Name</div>
                                    <div className="post-preview-li-time">1 min ago</div>
                                  </div>
                                </div>

                                <p className="post-preview-li-description">{description}</p>

                                {/* PDF Preview with Title for LinkedIn */}
                                {mediaFiles
                                  .filter((f) => f.platform === "LinkedIn" && f.mediaType === "pdf")
                                  .map((pdf, index) => (
                                    <div key={index} className="linkedin-pdf-preview mb-4">
                                      {pdf.title && (
                                        <div className="linkedin-pdf-title font-semibold text-gray-700 mb-2">
                                          {pdf.title}
                                        </div>
                                      )}
                                      <iframe
                                        src={pdf.previewUrl}
                                        width="100%"
                                        height="400px"
                                        title={`PDF Preview ${index}`}
                                        className="rounded border"
                                      />
                                    </div>
                                  ))}

                                {/* Image or Video preview if any */}
                                <MediaPreviewSlider mediaFiles={mediaFiles.filter(f => f.platform === "LinkedIn" && f.mediaType !== "pdf")} />

                                <div className="post-preview-linkedin-footer-note">
                                  🔗 See more on our website
                                </div>

                                <div className="post-preview-li-actions">
                                  <span><ThumbsUp size={16} /> Like</span>
                                  <span><MessageCircle size={16} /> Comment</span>
                                  <span><Share2 size={16} /> Share</span>
                                </div>
                                <div className="post-preview-li-date">July 25, 2025</div>
                              </div>
                            )}


                            {/* === TWITTER PREVIEW === */}
                            {selectedPlatform === "Twitter" && (
                              <div className="post-preview-twitter-card">
                                <div className="post-preview-tw-header">
                                  <UserCircle size={36} />
                                  <span className="post-preview-tw-handle">@yourhandle</span>
                                </div>

                                <p className="post-preview-tw-description">{description}</p>

                                <MediaPreviewSlider mediaFiles={mediaFiles.filter(f => f.platform === "Twitter")} />

                                <div className="post-preview-tw-tags">
                                  {hashtags.map((tag, i) => (
                                    <span key={i}>#{tag}</span>
                                  ))}
                                </div>

                                <div className="post-preview-tw-actions">
                                  <span><ThumbsUp size={16} /> Like</span>
                                  <span><MessageCircle size={16} /> Comment</span>
                                  <span><Share2 size={16} /> Repost</span>
                                </div>
                                <div className="post-preview-tw-date">July 18, 2025</div>
                              </div>
                            )}

                          </div>

                          <div className="post-preview-modal-footer">
                            <button
                              onClick={() => setShowPreviewModal(false)}
                              className="post-preview-modal-button"
                            >
                              Close Preview
                            </button>
                          </div>
                        </div>
                      </div>
                    )}

                  </div>
                </div>
              </div>
            )}
          </div>
        ) : currentStep === 3 ? (
          // Step 3: Scheduler
          <div className="post-page-wrapper">
            <div className="post-page-container post-form-card">
              <h2 className="form-title">Scheduler</h2>
              <div className="fb-scheduler-card">
                <label className="fb-scheduler-label">Publishing Options</label>
                <div className="fb-scheduler-options">
                  <label className="fb-scheduler-option">
                    <input
                      type="radio"
                      name="publishOption"
                      value="Publish Now"
                      checked={postData.publishOption === "Publish Now"}
                      onChange={() => handlePublishOptionChange("Publish Now")}
                    />
                    <span>Publish Now</span>
                  </label>
                  <label className="fb-scheduler-option">
                    <input
                      type="radio"
                      name="publishOption"
                      value="Schedule for Later"
                      checked={postData.publishOption === "Schedule for Later"}
                      onChange={() =>
                        handlePublishOptionChange("Schedule for Later")
                      }
                    />
                    <span>Schedule for Later</span>
                  </label>
                </div>
              </div>
              {postData.publishOption === "Schedule for Later" && (
                <div className="fb-scheduler-card">
                  <label className="fb-scheduler-label">
                    Select Date <span className="required">*</span>
                  </label>
                  <div className="date-picker-wrapper">
                    <input
                      type="date"
                      name="scheduleDate"
                      value={postData.scheduleDate}
                      onChange={handleDateTimeChange}
                      className="custom-date-input"
                      placeholder="mm/dd/yyyy"
                    />
                  </div>
                  <div className="time-picker-grid">
                    <div className="time-picker-column">
                      <label>Hour</label>
                      <select
                        name="scheduleHour"
                        value={postData.scheduleHour}
                        onChange={handleDateTimeChange}
                      >
                        {Array.from({ length: 12 }, (_, i) =>
                          String(i + 1).padStart(2, "0")
                        ).map((h) => (
                          <option key={h} value={h}>
                            {h}
                          </option>
                        ))}
                      </select>
                    </div>
                    <div className="time-picker-column">
                      <label>Minute</label>
                      <select
                        name="scheduleMinute"
                        value={postData.scheduleMinute}
                        onChange={handleDateTimeChange}
                      >
                        {["00", "15", "30", "45"].map((m) => (
                          <option key={m} value={m}>
                            {m}
                          </option>
                        ))}
                      </select>
                    </div>
                    <div className="time-picker-column">
                      <label>AM/PM</label>
                      <select
                        name="scheduleAmPm"
                        value={postData.scheduleAmPm}
                        onChange={handleDateTimeChange}
                      >
                        <option value="AM">AM</option>
                        <option value="PM">PM</option>
                      </select>
                    </div>
                  </div>
                </div>
              )}
              <div className="fb-scheduler-actions">
                <button
                  type="button"
                  onClick={() => {
                    if(finalloading) {

                    } else {
                      handleBack();
                    }
                    
                  }}
                  className="fb-step-button fb-back"
                >
                  Back
                </button>
                <button
                  type="button"
                  onClick={() => {
                    if(finalloading) {

                    } else {
                      handleFinalAction();
                    }
                    
                  }}
                  className="navigation-button"
                >
                  {
                  finalloading ?
                  "Uploading..." :
                  postData.publishOption === "Publish Now"
                    ? "Publish Now"
                    : "Schedule Post"}
                </button>
              </div>
            </div>
          </div>
        ) : null}
      </div>

      {/* Image Cropper Modal */}
      {showCropperModal && (
        <div className="crop-modal-overlay">
          <div className="crop-modal-wrapper">
            {/* Header */}
            <div className="crop-modal-header">
              <h5>Crop Image </h5>
              <button className="crop-modal-close" onClick={handleCancelCrop}>
                <XCircle size={20} />
              </button>
            </div>

            {/* Cropper */}
            <div className="crop-modal-canvas-container">
              <div className="crop-modal-canvas">
                {imageToCrop && (
                  <Cropper
     image={imageToCrop}
  crop={crop}
  zoom={zoom}
  aspect={aspect} // selected aspect ratio
  onCropChange={setCrop}
  onCropComplete={onCropComplete}
  onZoomChange={setZoom}
/>
                )}
              </div>
            </div>

            {/* Zoom Slider */}
            <div className="crop-modal-zoom">
              <input
                type="range"
                min={1}
                max={3}
                step={0.1}
                value={zoom}
                onChange={(e) => setZoom(Number(e.target.value))}
              />
            </div>
<div className="aspect-menu">
  {aspectOptions.map((opt) => (
    <button
      key={opt.label}
      className={`aspect-btn ${aspect === opt.value ? "active" : ""}`}
      onClick={() => setAspect(opt.value)}
    >
       <span>{opt.label}</span>
      {opt.icon}
     
    </button>
  ))}
</div>


            {/* Buttons */}
            <div className="crop-modal-actions">
              <button
                onClick={handleCancelCrop}
                className="crop-modal-btn cancel"
              >
                Cancel
              </button>
              <button
                onClick={handleApplyCrop}
                className="crop-modal-btn confirm"
              >
                Apply Crop
              </button>
            </div>
          </div>
        </div>
      )}

      {
        selectedplatforminsideRef.current ?
          <TagsModal
            isOpen={showtrendingtagsmodal}
            onClose={() => setshowtrendingtagsmodal(false)}
            // plaftorm={selectedPagesRef.current[selectedfortagmodalRef.current]}
            platform={selectedplatforminsideRef.current}
            onSave={handleselctedtag}
          /> : null
      }



      <ToastContainer />
    </div>
  );
};

export default Facebookpost;
